import { useState } from "react";

export default function ExpandableDescription({ text, collapsedLines = 2, className = "" }) {
  const [expanded, setExpanded] = useState(false);
  if (!text) return null;

  const lineClamp = collapsedLines === 3 ? "line-clamp-3" : "line-clamp-2";

  return (
    <button
      type="button"
      aria-expanded={expanded}
      onClick={() => setExpanded((current) => !current)}
      className={`block w-full text-left ${className}`}
    >
      <span className={expanded ? "block" : lineClamp}>{text}</span>
      <span className="mt-1.5 block text-[11px] font-semibold text-gold hover:text-[#E6BE3A]">
        {expanded ? "Tutup deskripsi" : "Selengkapnya"}
      </span>
    </button>
  );
}
